export default {
  survey: {
    instagram: 'Instagram',
    tiktok: 'TikTok',
    facebook: 'Facebook',
    pinterest: 'Pinterest',
    googleBing: 'Google / Bing',
    blogMagazine: 'Blog / Magazine',
    freundFreundin: 'Freund Freundin',
    other: 'Other',
    otherInputLabel: 'Where did you hear about us? (optional)',

    surveyAnsweredMessage: {
      title: 'Thank you!',
      message:
        'Many thanks for answering the survey, we hope you enjoy konfetti!',
    },
  },
}
